import AppWrapper from './AppWrapper.vue';

export default AppWrapper;



// WEBPACK FOOTER //
// ./src/uikit/components/AppWrapper/index.ts